import { useCallback } from 'react';
import { GetCommonResponse } from '@core/api/useCommon';

import { useAppContext } from '../../App.context';

type CommonTypes = keyof GetCommonResponse;

const useCommonEnums = () => {
    const {
        common,
        isLoading
    } = useAppContext();

    const findCommonNameById = useCallback(
        (commonType: CommonTypes, id?: number): string | null => {
            if (commonType === "segments") return null
            const matchedCommonType = (common?.[commonType] ?? []).find((item) => item.id === id);

            if (!matchedCommonType?.name) {
                return null;
            }

            return matchedCommonType.name;
        },
        [common],
    );

    return { findCommonNameById, common, isLoading };
};

export const customStatusesMap = {
    1: 'Live',
    2: 'Draft',
    3: 'Draft',
};

export enum SurveyStatusIdEnum {
    Draft = 0,
    Live = 1,
    Closed = 2,
}

export default useCommonEnums;
